<template>
    <div class="documents-style">
        <b-alert show dismissible fade v-if='successmsg'>{{ successmsg }}</b-alert>
        <!-- barsha -->
        <div class="row no-gutters py-2 mb-3">
            <div class="col-sm-5 company-form-box-title">
                <div class="custom-search">
                    <b-input-group class="mb-2">
                        <b-input-group-prepend is-text>
                            <b-icon icon="search"></b-icon>
                        </b-input-group-prepend>
                        <!-- alpha fix- maked search ... -->
                        <b-form-input type="search" placeholder="Search... " v-model="search"
                            @input="resetPagination()"></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="col-sm-7 cursor-pointer text-right company-form-box-title" v-if="flg == 1 || flg == 2">
                <template v-if="flg == 1 || flg == 2 && Object.keys(fiscal_year_options).length > 0">
                    <b-button @click="addNew(0)">+ Add Document</b-button>
                </template>
                <template v-if="flg == 1">
                    <!-- alpha fix- removed icon  -->
                    <b-button @click="addNew(1)">Request Document</b-button>
                </template>
                <!-- alpha fix- removed icon  -->
                <b-button @click="downloadSelected()">Download Selected</b-button>
            </div>
        </div>
        <!-- barsha -->
        <div class="">
            <!-- alpha fix- added border  -->
            <table class="table dataTable border">
                <thead>
                    <tr class="table-head">
                        <td class="checkbox-col">
                            <input type="checkbox" v-model="checkall" @click="selectAll()" />
                            <!-- <label></label> -->
                        </td>
                        <template v-for="column in columns">
                            <td v-if="column.name != 'created_at'" class="table-head-column">
                                <label class="custom-label mb-0 sort-label" :class="sortKey === column.name
                                        ? (sortOrders[column.name] > 0
                                            ? 'sorting_asc'
                                            : 'sorting_desc')
                                        : 'sorting'
                                    " @click="sortBy(column.name)">
                                    <span class="label-text">
                                        {{ column.label }}
                                    </span>
                                </label>
                            </td>
                        </template>
                        <th>File</th>
                        <th v-if="flg == 1 || flg == 2">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr class="hover-bg table-row border-bottom mx-2" v-for="doc in paginatedData" :key="doc.id">
                        <td class="checkbox-col ">
                            <input type="checkbox" class="checkall_ptrfa justify-content-center"
                                v-if="doc.file_name != ''" v-model="checked_list" :value="'uploaded:' + doc.id" />
                            <!-- <label></label> -->
                        </td>
                        <td>
                            <div class="td-1">{{ doc.name }}</div>
                        </td>
                        <td>
                            <div class="td-2">{{ doc.fiscal_year }}</div>
                        </td>
                        <td>
                            <div class="td-3">{{ doc.date_of_filing_return }}</div>
                        </td>
                        <td>
                            <div class="td-4">{{ doc.tax_zone }}</div>
                        </td>
                        <td>
                            <div class="td-5">

                                <div class="col-sm-12 align-self-center mt-2 text-center" v-if="doc.file_name != ''">
                                    <b-link @click="downloadFileContent(doc.file_name)">
                                        <!-- barsha -->
                                        <!-- <b-icon icon="download" scale="2"></b-icon> -->
                                        <img :src="$api_url + '/images/download_image.png'" class="" />
                                        <!-- barsha -->

                                    </b-link>

                                    <template
                                        v-if="(doc.flg == 1) && (doc.submit_with_in != null) && (doc.submit_with_in != '0000-00-00')">
                                        <span v-if="checkPastDate(doc.submit_with_in) == true"
                                            class="text-danger ml-4 td-5-span">Requested
                                            (Upload by {{ doc.submit_with_in }})</span>
                                        <span class="ml-4" v-else>Requested (Upload by {{ doc.submit_with_in }})</span>
                                    </template>
                                </div>
                                <div
                                    v-else-if="(doc.flg == 1) && (doc.submit_with_in != null) && (doc.submit_with_in != '0000-00-00')">
                                    <span v-if="checkPastDate(doc.submit_with_in) == true"
                                        class="text-danger td-5-span">Requested (Upload by
                                        {{ doc.submit_with_in }})</span>
                                    <span v-else>Requested (Upload by {{ doc.submit_with_in }})</span>
                                </div>
                                <div v-else>
                                    <span class="text-danger td-5-span">
                                        No file uploaded
                                    </span>
                                </div>
                            </div>

                        </td>

                        <td class="float-right" v-if="flg > 0">
                            <div class="position-relative">
                                <b-button-toolbar>
                                    <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle"
                                        style="font-size: 16px;" href="#" role="button" data-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"><b-icon
                                            icon="three-dots-vertical"></b-icon></a>
                                    <div class="dropdown-menu action-dropdown-menu position_absolute"
                                        aria-labelledby="actionDropdown ">
                                        <b-button-group>
                                            <b-button variant="outline-secondary" @click="editDocument(doc.id)">
                                                <b-icon icon="pencil"></b-icon> Upload
                                            </b-button>
                                            <b-button variant="outline-secondary" @click="deleteDocument(doc.id)"
                                                v-if="flg == 1">
                                                <b-icon icon="trash"></b-icon> Delete
                                            </b-button>
                                        </b-button-group>
                                    </div>
                                </b-button-toolbar>
                            </div>
                        </td>
                    </tr>

                    <tr v-if="paginatedData.length == 0">
                        <td :colspan=7>
                            <div class="mt-4 d-flex justify-content-center"> {{ blankmsg }} </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <!-- alpha fix- chnaged the pagination style and move outside of table  -->
            <div class="row py-2 no-margin" v-if="paginatedData.length > 0">
                <div class="col-md-12 p-0 no-margin">
                    <b-pagination-nav class="float-right mt-1" v-model="pagination.currentPage"
                        :number-of-pages="pagination.pages" base-url="#" first-number last-number></b-pagination-nav>
                </div>
            </div>

        </div>




        <b-modal id="bv-modal-ptrfa" size="lg" :modal-class="'w-600'" hide-footer
            title="Personal Tax Return Filing Acknowledgement" v-if="flg > 0">
            <ul>
                <li clase="text-uppercase" v-for='data in errormsg'>{{ data[0] }}</li>
            </ul>
            <b-overlay :show="showoverlay" rounded="sm" class="trz_overlay_custom">
                <b-form @submit.stop.prevent="onSubmit">
                    <input type="hidden" v-model="fdata.id" name="id">

                    <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field"
                        label-for="fiscal_year" v-if="fdata.id > 0">
                        <b-form-input disabled id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year"
                            v-validate="{ required: true, min: 3 }" :state="validateState('fiscal_year')"
                            aria-describedby="fiscal_year-feedback" data-vv-as="Fiscal Year"></b-form-input>
                        <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year')
                        }}</b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group id="fiscal_year-group" label="Fiscal Year" class="required-field"
                        label-for="fiscal_year" v-else>
                        <b-form-select id="fiscal_year" name="fiscal_year" v-model="fdata.fiscal_year"
                            v-validate="{ required: true }" :options="fiscal_year_options"
                            :state="validateState('fiscal_year')" aria-describedby="fiscal_year-feedback"
                            data-vv-as="Fiscal Year"></b-form-select>
                        <b-form-invalid-feedback id="fiscal_year-feedback">{{ veeErrors.first('fiscal_year')
                        }}</b-form-invalid-feedback>
                    </b-form-group>

                    <template v-if="request == 0">

                        <b-form-group id="date_of_filing_return-group" label="Date of Filing of Return [YYYY-MM-DD]"
                            class="required-field" label-for="date_of_filing_return">
                            <b-input-group class="mb-3">
                                <b-form-input id="date_of_filing_return" name="date_of_filing_return"
                                    v-model="fdata.date_of_filing_return" v-validate="{ required: true, }" type="text"
                                    placeholder="YYYY-MM-DD" autocomplete="off"
                                    :state="validateState('date_of_filing_return')"
                                    aria-describedby="date_of_filing_return-feedback"
                                    data-vv-as="Date of Filing of Return"></b-form-input>
                                <b-input-group-append class="btn-radius-8">
                                    <b-form-datepicker id="date_of_filing_return" button-only right locale="en-US"
                                        v-model="fdata.date_of_filing_return"></b-form-datepicker>
                                </b-input-group-append>
                                <b-form-invalid-feedback id="date_of_filing_return-feedback">{{
                                    veeErrors.first('date_of_filing_return') }}</b-form-invalid-feedback>
                            </b-input-group>
                        </b-form-group>

                        <b-form-group id="serial_number-group" label="Serial Number" class="required-field"
                            label-for="serial_number">
                            <b-form-input id="serial_number" name="serial_number" v-model="fdata.serial_number"
                                v-validate="{ required: true, min: 3 }" :state="validateState('serial_number')"
                                aria-describedby="serial_number-feedback" data-vv-as="Serial Number"></b-form-input>
                            <b-form-invalid-feedback id="serial_number-feedback">{{ veeErrors.first('serial_number')
                            }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="tax_zone-group" label="Tax Zone" class="required-field" label-for="tax_zone">
                            <b-form-select id="tax_zone" name="tax_zone" v-model="fdata.tax_zone"
                                v-validate="{ required: true }" :options="tax_zones" :state="validateState('tax_zone')"
                                aria-describedby="tax_zone-feedback" data-vv-as="Tax Zone"></b-form-select>
                            <b-form-invalid-feedback id="tax_zone-feedback">{{ veeErrors.first('tax_zone')
                            }}</b-form-invalid-feedback>
                        </b-form-group>

                        <b-form-group id="taxes_circle-group" label="Taxes Circle" class="required-field"
                            label-for="taxes_circle">
                            <b-form-input id="taxes_circle" name="taxes_circle" v-model="fdata.taxes_circle"
                                v-validate="{ required: true, min: 3 }" :state="validateState('taxes_circle')"
                                aria-describedby="taxes_circle-feedback" data-vv-as="Taxes Circle"></b-form-input>
                            <b-form-invalid-feedback id="taxes_circle-feedback">{{ veeErrors.first('taxes_circle')
                            }}</b-form-invalid-feedback>
                        </b-form-group>


                        <b-form-group id="upload_file-group" label="File" label-for="upload_file">
                            <b-form-file id="upload_file" v-model="upload_file"
                            @change="checkFileType($event, 'upload_file', ['.jpg', '.png', '.gif', '.pdf', '.doc', '.docx'])"
                                accept=".jpg, .png, .gif, .pdf , .doc , .docx"
                                placeholder="Choose a file or drop it here..."
                                drop-placeholder="Drop file here..."></b-form-file>

                        </b-form-group>

                    </template>

                    <b-form-group id="submit_with_in-group" label="Deadline [YYYY-MM-DD] - Optional"
                        label-for="submit_with_in" class="mt-4" v-if="this.flg == 1">
                        <b-input-group class="mb-3">
                            <b-form-input id="submit_with_in" name="submit_with_in" v-model="fdata.submit_with_in"
                                type="text" placeholder="YYYY-MM-DD" autocomplete="off"></b-form-input>
                            <b-input-group-append class="btn-radius-8">
                                <b-form-datepicker id="submit_with_in" button-only right locale="en-US"
                                    v-model="fdata.submit_with_in" :min="date_min"></b-form-datepicker>
                            </b-input-group-append>
                        </b-input-group>
                    </b-form-group>

                    <b-form-group label=" " class="text-center">
                        <b-button class="ml-2 btn-primary custom-wizard-btn" @click="resetForm()">Reset</b-button>
                        <b-button class="btn-primary" type="submit" variant="primary">Submit</b-button>
                    </b-form-group>
                </b-form>
            </b-overlay>
        </b-modal>

    </div>
</template>


<script>
export default {

    mounted() {

    },
    props: ['flg'],
    data() {

        let sortOrders = {};
        let columns = [
            { label: 'Name', name: 'name' },
            { label: 'Fiscal Year', name: 'fiscal_year' },
            { label: 'Date', name: 'date_of_filing_return' },
            { label: 'Tax Zone', name: 'tax_zone' },
            { label: '', name: 'created_at' },

        ];
        columns.forEach((column) => { sortOrders[column.name] = -1; });

        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const minDate = new Date(today);


        return {

            date_min: minDate,
            checked_list: [],
            checkall: false,

            tax_zones: [],
            documents: [],
            successmsg: null,
            errormsg: [],
            showoverlay: false,
            fdata: { id: null, name: null, submit_with_in: '' },
            upload_file: null,
            fiscal_year_options: [],

            request: 0,

            blankmsg: 'Fetching data..',
            search: '',

            columns: columns,
            sortKey: 'name',
            sortOrders: sortOrders,
            length: 10,
            pagination: { currentPage: 1, total: '', nextPage: '', prevPage: '', from: '', to: '', pages: 1 },

        }
    },
    methods: {
        downloadSelected: function () {
            if (this.checked_list.length == 0) {
                this.$bvToast.toast('No document selected.', {
                    title: `Warning`,
                    variant: 'warning',
                    solid: true
                });

                return false;
            }

            if (!this.checkNet()) return false;
            let currentObj = this;

            let url = '';
            url = this.$api_url + '/documents/zip/download';

            this.$bvToast.toast('It might take a while', {
                title: `Info`,
                variant: 'info',
                solid: true
            });

            let formData = new FormData();

            formData.append('checked_list', this.checked_list);
            formData.append('type', 'ptrfa');

            axios.post(url, formData)
                .then(function (response) {
                    this.downloadFileContent('' + response.data);

                }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        selectAll: function () {
            this.checkall = !this.checkall;
            var y = document.getElementsByClassName("checkall_ptrfa");
            var i;
            for (i = 0; i < y.length; i++) {
                if (y[i].checked != this.checkall)
                    y[i].click();
            }
        },
        getTaxZone: function () {

            if (!this.checkNet()) return false;
            axios.get(this.$api_url + '/company/taxzone', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {

                this.tax_zones = [{ value: null, text: "Select..." }].concat(response.data.tax_zone);
                this.tax_circle = response.data.tax_circle;
            }.bind(this)).catch(function (error) { this.serverError(error); });
        },
        getAvailableFiscalYear: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;

            axios.get(this.$api_url + '/get-employee-fiscal-year').then(function (response) {
                if (response.data.length > 0) {
                    this.fiscal_year_options = response.data;
                }

            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        getDocumentList: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;
            axios.get(this.$api_url + '/personal-tax-return-filing-ack', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.documents = response.data.documents;
                this.fiscal_year_options = response.data.fiscal_years_options;

                if (this.documents.length == 0)
                    this.blankmsg = "No doucments found";

                else {
                    this.sortOrders['created_at'] = 1;
                    this.sortBy('created_at');
                }


            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editDocument: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;


            axios.get(this.$api_url + '/personal-tax-return-filing-ack/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                this.request = 0;

                this.$validator.reset();

                this.$bvModal.show('bv-modal-ptrfa');

            }.bind(this)).catch(function (error) { currentObj.hr_showoverlay = false; currentObj.serverError(error); });

        },
        deleteDocument(id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            // alpha fix- chnaged the tiele to documnet
            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this Document.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.hr_showoverlay = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url + '/personal-tax-return-filing-ack/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });

                                this.getDocumentList();

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.hr_showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.hr_showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', fiscal_year: this.getCurrentFinancialYear(), submit_with_in: '' };
            this.upload_file = null;
            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew(x) {

            this.resetForm();

            if (x == 1) {
                this.getAvailableFiscalYear();
                this.fdata.flg = 1;
                this.request = 1;
            }
            else {
                this.fdata.flg = 0;
                this.request = 0;
            }
            this.$bvModal.show('bv-modal-ptrfa');
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                if (this.fdata.submit_with_in != 'undefined' && this.fdata.submit_with_in != null && this.fdata.id == 0) {

                    if (this.fdata.submit_with_in != '') {
                        let submit_with_in = this.fdata.submit_with_in.split('-');
                        const submit_with_in_date = new Date(submit_with_in[0], submit_with_in[1] - 1, submit_with_in[2]);
                        const submit_with_in_date_final = new Date(submit_with_in_date);



                        const now2 = new Date()
                        const today2 = new Date(now2.getFullYear(), now2.getMonth(), now2.getDate())
                        const currentDate = new Date(today2);

                        if (currentDate.getTime() > submit_with_in_date_final.getTime()) {
                            this.showoverlay = false;
                            this.$bvToast.toast('Deadline cannot be an older date !', {
                                title: `Error`,
                                variant: 'danger',
                                solid: true
                            });

                            return;

                        }

                    }

                }

                let formData = new FormData();

                if (this.upload_file)
                    formData.append('upload_file', this.upload_file);

                for (let [key, value] of Object.entries(this.fdata)) {
                    var nm = `${key}`;
                    var fval = `${value}`;
                    formData.append(nm, fval);
                    //console.log(`${key}: ${value}`);
                }

                formData.append('updated_by', this.flg);

                axios.post(this.$api_url + '/personal-tax-return-filing-ack/details', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.getDocumentList();

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay = false;
                        this.resetForm();

                        this.$bvModal.hide('bv-modal-ptrfa');

                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getTaxZone();
        this.getDocumentList();

        Fire.$on('reloaddocuments', () => { this.getDocumentList() })
    },
    computed:
    {
        filteredData() {
            let filtered_list = this.documents;
            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });

                if (filtered_list.length == 0)
                    this.blankmsg = "No doucments found";
            }

            let sortKey = this.sortKey;
            let order = this.sortOrders[sortKey] || 1;
            if (sortKey) {
                filtered_list = filtered_list.slice().sort((a, b) => {
                    let index = this.getIndex(this.columns, 'name', sortKey);
                    a = String(a[sortKey]).toLowerCase();
                    b = String(b[sortKey]).toLowerCase();
                    if (this.columns[index].type && this.columns[index].type === 'date') {
                        return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                    }
                    else if (this.columns[index].type && this.columns[index].type === 'number') {
                        return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                    }
                    else {
                        return (a === b ? 0 : a > b ? 1 : -1) * order;
                    }
                }
                );
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        }
    }
}
</script>
